// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"45309172","822":"62a1e4e5"}[chunkId] + ".chunk.css";
};